import useAsync from 'Hooks/useAsync';
import { getAllNotesForBooking } from 'Services/Api/_HumanWritten/NotesService';

export function useBookingNotesModal(bookingId: string) {
	const response = useAsync(() => getAllNotesForBooking(bookingId), []);

	return response;
}
